import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { RealtimeKitProvider } from "@cloudflare/realtimekit-react";
import RealtimeKitMeeting from "./realtimeKitMeeting";
import { toast } from "react-toastify";
import { getUserRealtimeKitToken } from "../../config/service";
import { Network } from "../../config/axios";
import { initRealtimeKitMeeting } from "../../utils/realtimeKitInit";

const RealtimeKitMeetingContainer = ({ mId }) => {
  const [meeting, setMeeting] = useState(null);
  const { meetingId } = useParams();
  const location = useLocation();
  const [isMeetingFinish, setIsMeetingFinish] = useState({
    status: true,
    message: "",
  });

  useEffect(() => {
    let cancelled = false;

    const fetchAuthTokenAndInit = async () => {
      try {
        const meetingIdentifier = mId || meetingId;
        if (!meetingIdentifier) return;

        const isJoining = location.pathname.includes("/join");
        let authToken;

        if (isJoining) {
          const response = await Network().get(
            `meeting/getRealtimeKitMeetingToken/${meetingId}`
          );
          const { status, data } = response || {};

          if (status === 200) {
            if (data?.statusCode === 402) {
              if (cancelled) return;
              setIsMeetingFinish({
                status: data?.success,
                message: data?.message,
              });
              toast.error(data?.message, { toastId: "status" });
              return;
            }
            authToken = data?.token;
          } else {
            toast.error(data?.message || "Failed to fetch meeting token.", {
              toastId: "fetchError",
            });
            return;
          }
        } else {
          const payload = { meetingId: meetingIdentifier };
          const { data: tokenResponse } = await getUserRealtimeKitToken(payload);

          if (tokenResponse?.code === 200) {
            authToken = tokenResponse?.token;
          } else {
            toast.error(tokenResponse?.message || "Failed to retrieve token.", {
              toastId: "tokenError",
            });
            return;
          }
        }

        if (!authToken) {
          toast.error("Failed to retrieve meeting token.", {
            toastId: "missingToken",
          });
          return;
        }

        const client = await initRealtimeKitMeeting(authToken, {
          audio: true,
          video: true,
        });
        if (cancelled) return;
        setMeeting(client);
      } catch (error) {
        if (cancelled) return;
        toast.error(error?.message || "Failed to initialize the meeting.", {
          toastId: "initError",
        });
      }
    };

    setMeeting(null);
    fetchAuthTokenAndInit();

    return () => {
      cancelled = true;
    };
  }, [meetingId, mId, location.pathname]);

  return (
    <RealtimeKitProvider
      value={meeting}
      fallback={
        <div className="loading-design">
          {!isMeetingFinish?.status ? (
            <h2>{isMeetingFinish?.message}</h2>
          ) : (
            <h2>Loading...</h2>
          )}
        </div>
      }
    >
      <RealtimeKitMeeting />
    </RealtimeKitProvider>
  );
};

export default RealtimeKitMeetingContainer;
